import { Button, Drawer, Grid, Typography } from "@mui/material"
import React from "react"
import { useForm } from "react-hook-form";
import { WSIcons } from "../../../commonFunctions/iIcons";
import WSTextField from "../../../Components/TextBox/WSTextBox";
import WSSelectField from "../../../Components/Select/WSSelect";
import WSPhone from "../../../Components/Phone/WSPhone";
import WSSCheckBoxField from "../../../Components/CheckBox/WSCheckBox";
import config from "../../../Config/clientConfig.json";
import WSDateField from "../../../Components/DateField/WSDateField";
import WSRadioField from "../../../Components/Radio/WSRadio";


export const PaymentSearchDrawer:React.FC<any>=React.memo(({open,onClose})=>{
    const {
        register,
        control,
        handleSubmit
    }= useForm();
    return(
<Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: { width: '20rem', padding: '1rem', top: '5rem', height: `calc(100% - 5rem)` }, // Adjust width and padding to match your design
      }}
    >
      <Grid container direction="column" spacing={2}>
        {/* Header with Close Button */}
        <Grid item container justifyContent="space-between" alignItems="center">
          <Typography variant="h6" fontWeight="bold" color={"green"}>
           Search
          </Typography>
          <WSIcons.CloseIcon onClick={onClose}  />
        </Grid>
        </Grid>
        <Grid item container spacing={2} alignItems="center" sx={{mt:2}}>
         
          <Grid item xs={12}>
          <WSTextField
            label={"Receipt No"}
            {...register("receiptno")}
            id="receiptno"
            name="receiptno"
            control={control}
            rules={{ required: false }}
            labelType="Normal"/>
          </Grid>
          <Grid item xs={12}>
          <WSSelectField
              rules={{ required: true }}
              {...register("paymenttype")}
              id="paymenttype"
              control={control}
              defaultValue={"0"}
              label="payment Type"
              name="paymenttype"
              labelType="Normal"
              options={config.paymentTypesconfig.staticOptionData}
            />
          </Grid>
          <Grid item xs={12}>
          <Typography gutterBottom mb={1.6} fontSize={"0.875rem"}>From Date</Typography>

          <WSDateField
                    id="fromdate"
                    name="fromdate"
                    label=""
                    dateFormat="D/MM/YYYY"
                    control={control}
                    defaultValue={null}
                    rules={{ required: false }}
                />
          </Grid>
          <Grid item xs={12}>
          <Typography  gutterBottom mb={1.6} fontSize={"0.875rem"}>To Date</Typography>

          <WSDateField
                    id="todate"
                    name="todate"
                    label=""
                    dateFormat="D/MM/YYYY"
                    control={control}
                    defaultValue={null}
                    rules={{ required: false }}
                />
          </Grid>
          <Grid item xs={12}>
          <WSSCheckBoxField
                        id="unassignedpayments"
                        {...register('unassignedpayments')}
                        label="Show Unassigned Payments"
                        control={control}
                        rules={{ required: false }}
                        defaultValue={false}
                    />
          </Grid>
          
          <Grid item container justifyContent="flex-end" spacing={2} sx={{ mt: 2 }}>
          <Grid item>
            <Button variant="outlined" sx={{color:"green",borderColor:"green"}}>
<WSIcons.SyncIcon/>
            </Button>
          </Grid>
          <Grid item>
            <Button variant="contained" color="success">
              Search
            </Button>
          </Grid>
        </Grid>
        </Grid>
        </Drawer>
    )
})